import { useTranslation } from "react-i18next";
import SpirisIcon from "../Fundamentals/Icon/SpirisIcon";

const UpvoteBudgetChip = ({ remaining, total }) => {
    const { t } = useTranslation();
    const depleted = remaining <= 0;

    return (
        <span className={`feedback-budget-chip label d-inline-flex align-items-center gap-4 flex-none text-nowrap ${depleted ? "text-secondary" : "label-info"}`}>
            <SpirisIcon name="star" size="sm" />
            {t("feedback.upvotesLeft", { remaining, total })}
        </span>
    );
};

export default UpvoteBudgetChip;
